<template>
  <div id="header">
    <div class="header-box">
      <router-link to="/" class="logo-box"
        ><img class="logo" src="~@/assets/images/logo.png"
      /></router-link>

      <div :class="navAct ? 'nav-box' : 'nav-box active'" :style="navH">
        <ul>
          <li
            v-for="(iten, index) in navdata.navlist"
            @click="mainChoose(iten.name)"
            :class="heiAct == iten.name ? 'head-li active' : 'head-li'"
          >
            <router-link v-if="iten" :to="iten.url">{{
              iten.title
            }}</router-link>
          </li>
          <li class="languageChoose-li head-li">
            <div class="pc languageChoose-on">
              <span>{{ navdata.language }}</span
              ><img class="sj-icon" src="~@/assets/images/sj-icon.png" />
              <div class="languageChoose">
                <!-- <span :class="language == 'TC' ? ' active' : ''" @click="languageChoose('TC')">繁中la</span> -->
                <!-- <span :class="language == 'Japanese' ? ' active' : ''" @click="languageChoose('Japanese')">日本語</span> -->
                <span
                  :class="language == 'english' ? 'active' : ''"
                  @click="languageChoose('english')"
                  >EN</span
                >
              </div>
            </div>
            <div class="yd">
              <!-- <span :class="language=='TC'?'active':''" @click="languageChoose('TC')">繁中yd</span> -->
              <!-- <span :class="language == 'Japanese' ? 'active' : ''" @click="languageChoose('Japanese')">日本語</span> -->
              <span
                :class="language == 'english' ? 'active' : ''"
                @click="languageChoose('english')"
                >EN</span
              >
            </div>
          </li>
        </ul>
      </div>
      <div class="navbar-toggle" @click="navToggle()">
        <span class="sr-only"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navdata: "",
      navAct: true,
      navH: {
        height: "auto"
      },
      heiAct: 0,
      language: "english"
    };
  },
  props: {
    resData: {}
  },
  watch: {
    resData(newData) {
      this.navdata = newData;
    }
  },
  methods: {
    mainChoose(type) {
      this.heiAct = type;
      this.navToggle();
    },
    languageChoose(val) {
      this.language = val;
      this.$parent.languagefun(val);
      this.navToggle();
    },
    navToggle() {
      if (document.body.clientWidth < 1000) {
        this.navAct = !this.navAct;
        let h =
          document.getElementsByTagName("li")[0].offsetHeight *
          document.getElementsByClassName("head-li").length;
        if (this.navAct) {
          this.navH = {
            height: 0
          };
        } else {
          this.navH = {
            height: h + "px"
          };
        }
      }
    }
  },
  mounted() {
    let this_ = this;
    this.heiAct = this.$route.name;
    if (this.heiAct == "newDetails") {
      this.heiAct = "news";
    }
    console.log("===>", this.heiAct);
    this.$parent.getlan();
    this.language = this.$parent.languages;
    if (document.body.clientWidth < 1000) {
      this.navH = {
        height: 0
      };
    }
    window.addEventListener("resize", function() {
      if (document.body.clientWidth < 1000) {
        this_.navH = {
          height: 0
        };
      } else {
        this_.navH = {
          height: "auto"
        };
      }
    });
  }
};
</script>

<style scoped>
#header {
  background-color: white;
}

.header-box {
  height: 105px;
  max-width: 1200px;
  margin: auto;
  position: relative;
  text-align: center;
}

.logo-box {
  display: inline-block;
  margin-right: 20px;
}

.logo {
  height: 75px;
  margin: 15px 0;
}

.nav-box {
  display: inline-block;
  font-size: 0;
}

.nav-box li {
  display: inline-block;
  font-size: 28px;
  line-height: 105px;
  cursor: pointer;
  font-weight: 700;
  position: relative;
  margin: 0 20px;
}

.nav-box li a {
  padding: 0 20px;
  color: black;
  display: block;
  font-family: "dbtfont";
}

.nav-box li.active a {
  color: #57749c;
}

.active .router-link-active {
  background: url("~@/assets/images/title-bottom2.png") center 60px no-repeat;
  background-size: 100%;
}

.nav-box li span {
  display: inline-block;
  margin: 0 5px;
  font-family: "dbtfont";
}

.nav-box li span.active {
  color: #57749c;
}

.navbar-toggle {
  position: absolute;
  right: 3%;
  padding: 9px 10px;
  top: 28px;
  margin-right: 15px;
  background-color: white;
  background-image: none;
  border: 1px solid #ddd;
  border-radius: 4px;
  display: none;
  cursor: pointer;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.navbar-toggle .icon-bar {
  display: block;
  width: 22px;
  height: 2px;
  border-radius: 1px;
  background-color: #888;
}

.navbar-toggle .icon-bar + .icon-bar {
  margin-top: 4px;
}

.languageChoose-on:hover .languageChoose {
  display: block;
}

.languageChoose {
  position: absolute;
  top: 105px;
  z-index: 5;
  width: 100%;
  background-color: #f6f6f6;
  /* background-color: red; */
  display: none;
}

.nav-box .languageChoose span {
  display: block;
  width: 100%;
  margin: 10% 0;
  text-align: center;
  line-height: 35px;
}

.yd {
  display: none;
}

@media screen and (max-width: 1000px) {
  .header-box {
    height: 90px;
    max-width: 750px;
  }

  .logo-box {
    display: block;
    text-align: center;
  }

  .logo {
    height: 60px;
    margin: 15px 10px;
    /* float: left; */
  }

  .nav-box {
    float: left;
    width: 100%;
    position: absolute;
    z-index: 20;
    background-color: white;
    top: 90px;
    transition: all 0.2s ease-in;
    height: 0;
    overflow: hidden;
    display: block;
  }

  .nav-box ul {
    padding: 0 5%;
  }

  .nav-box li {
    line-height: initial;
    display: block;
    width: 100%;
    text-align: left;
    box-sizing: border-box;
    font-size: 16px;
    border-top: 1px solid #ddd;
  }

  .nav-box li a {
    padding: 3% 0;
  }

  .nav-box li:nth-last-of-type(1) {
    text-align: center;
    padding: 3% 0;
  }

  .nav-box li span {
    margin: 0 10%;
  }

  .navbar-toggle {
    display: block;
  }

  .pc {
    display: none;
  }

  .yd {
    display: block;
  }

  .active .router-link-active {
    background: url();
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue